/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetDownloadUrlQueryResponse, FilesControllerGetDownloadUrlPathParams, FilesControllerGetDownloadUrlQueryParams, FilesControllerGetDownloadUrl400, FilesControllerGetDownloadUrl401, FilesControllerGetDownloadUrl403, FilesControllerGetDownloadUrl404 } from "../../models/filesController/FilesControllerGetDownloadUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetDownloadUrl } from "../../clients/filesService/filesControllerGetDownloadUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetDownloadUrlQueryKey = (id: FilesControllerGetDownloadUrlPathParams["id"], params: FilesControllerGetDownloadUrlQueryParams = {}) => [{
  url: '/api/v1/files/:id/download-url',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type FilesControllerGetDownloadUrlQueryKey = ReturnType<typeof filesControllerGetDownloadUrlQueryKey>;
export function filesControllerGetDownloadUrlQueryOptions(id: FilesControllerGetDownloadUrlPathParams["id"], params?: FilesControllerGetDownloadUrlQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetDownloadUrlQueryKey(id, params);
  return queryOptions<FilesControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<FilesControllerGetDownloadUrl400 | FilesControllerGetDownloadUrl401 | FilesControllerGetDownloadUrl403 | FilesControllerGetDownloadUrl404>, FilesControllerGetDownloadUrlQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetDownloadUrl(id, params, config);
    }
  });
}

/**
 * @description Generates a presigned URL for direct S3 download of the file. By default downloads from kira-processed path (processed PDF). Set useOriginal=true to download from original upload location. Set inline=true to display in browser instead of forcing download. Attachment URLs expire after 5 minutes by default (max 15); inline URLs after 1 hour (max 1 hour).
 * @summary Get presigned download URL for a file
 * {@link /api/v1/files/:id/download-url}
 */
export function useFilesControllerGetDownloadUrl<TData = FilesControllerGetDownloadUrlQueryResponse, TQueryData = FilesControllerGetDownloadUrlQueryResponse, TQueryKey extends QueryKey = FilesControllerGetDownloadUrlQueryKey>(id: FilesControllerGetDownloadUrlPathParams["id"], params?: FilesControllerGetDownloadUrlQueryParams, options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<FilesControllerGetDownloadUrl400 | FilesControllerGetDownloadUrl401 | FilesControllerGetDownloadUrl403 | FilesControllerGetDownloadUrl404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetDownloadUrlQueryKey(id, params);
  const query = useQuery({
    ...filesControllerGetDownloadUrlQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FilesControllerGetDownloadUrl400 | FilesControllerGetDownloadUrl401 | FilesControllerGetDownloadUrl403 | FilesControllerGetDownloadUrl404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}